export class SnDetectionBox {
  public startX: number;

  public startY: number;

  public endX: number;

  public endY: number;

  public center: number[];

  public area: number;

  public height: number;

  public width: number;
}
